export default __webpack_public_path__ + "static/media/pictogramBeaconPresent48.0031e0aa.svg";